import { CookieModule as o, LoggerModule as e, HttpModule as r } from "@packages/common";
import { AuthService as t } from "./main7.js";
import { TokenService as u } from "./main71.js";
const l = {
  name: "AuthModule",
  modules: [o, e, r],
  providers: [t, u]
};
export {
  l as AuthModule
};
